// relatorios-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "(cupons": "(cupones",
    "(lidas + aberturas influenciadas) / enviadas": "(leídas + aperturas influenciadas) / enviadas",
    ") comparada com o benchmark de push do setor — mesma base de cálculo (sobre enviadas).": ") comparada con el benchmark de push del sector — misma base de cálculo (sobre enviadas).",
    "Abastecimentos fora do App": "Cargas de combustible fuera de la aplicación",
    "Abastecimentos no App": "Cargas de combustible en la aplicación",
    "Abastecimentos por Cliente": "Cargas de combustible por cliente",
    "Abastecimentos por Frentista": "Cargas de combustible por playero",
    "Abastecimentos por Posto": "Cargas de combustible por estación",
    "Agrupar por": "Agrupar por",
    "Ao Vivo": "En vivo",
    "Apenas produtos abaixo do estoque mínimo": "Solo productos por debajo del inventario mínimo",
    "Bicos (Pressione Enter)": "Picos (presione Enter)",
    "Bruto": "Bruto",
    "Carregando Google Maps...": "Cargando Google Maps...",
    "Cashback": "Cashback",
    "Cliente sem nome": "Cliente sin nombre",
    "Clientes com saldo": "Clientes con saldo",
    "Clientes inativos": "Clientes inactivos",
    "Cobranças selecionadas:": "Cobros seleccionados:",
    "Comprovante de Pagamento": "Comprobante de pago",
    "Conquista": "Logro",
    "Cupons não validados": "Cupones no validados",
    "Custo parceiro": "Costo del socio comercial",
    "Data Atribuição Final": "Fecha de atribución final",
    "Data Atribuição Inicial": "Fecha de atribución inicial",
    "Data de Atribuição": "Fecha de atribución",
    "Emitidas": "Emitidas",
    "Encheu Tanque": "Llenó el tanque",
    "Engajamento total do time": "Compromiso total del equipo",
    "Erro ao cancelar cobranças": "Error al cancelar los cobros",
    "Erro ao carregar Google Maps": "Error al cargar Google Maps",
    "Erro ao carregar dados do relatório": "Error al cargar datos del reporte",
    "Erro ao carregar locais da rede": "Error al cargar locales de la red",
    "Erro ao carregar pontos expirados": "Error al cargar puntos vencidos",
    "Erro ao carregar pontos gerados e resgatados": "Error al cargar puntos generados y canjeados",
    "Erro ao carregar produtos da rede": "Error al cargar productos de la red",
    "Erro ao conferir consistência": "Error al verificar la consistencia",
    "Erro ao recalcular": "Error al recalcular",
    "Erro ao registrar pagamento": "Error al registrar el pago",
    "Estoque Controlado": "Inventario controlado",
    "Estornadas": "Revertidas",
    "Evolução Mensal": "Evolución mensual",
    "Expiradas": "Vencidas",
    "Extrato de estoque mínimo": "Extracto de inventario mínimo",
    "Favoritado em": "Favorito desde",
    "Favoritos no geral": "Favoritos en general",
    "Favoritos no período": "Favoritos en el período",
    "Fonte:": "Fuente:",
    "Funil do período": "Embudo del período",
    "Gerado": "Generado",
    "ID Transação Dotz": "ID de transacción Dotz",
    "Indefinido": "Indefinido",
    "Itens": "Ítems",
    "Locais de resgate": "Lugares de canje",
    "Local de abastecimento": "Lugar de carga de combustible",
    "Líquido": "Neto",
    "Mapa de Abastecimentos": "Mapa de cargas de combustible",
    "Melhor horário": "Mejor horario",
    "Min. de abastecimentos": "Mín. de cargas de combustible",
    "Modo TV (Fullscreen)": "Modo TV (pantalla completa)",
    "Mostrar produtos esgotados": "Mostrar productos agotados",
    "Movimentações do Estoque": "Movimientos del inventario",
    "Máximo": "Máximo",
    "Métrica": "Métrica",
    "Mês": "Mes",
    "Nenhum registro encontrado": "No se encontraron registros",
    "Nome do devedor": "Nombre del deudor",
    "Nome/Identfid": "Nombre/Identif",
    "Nota Média": "Calificación promedio",
    "Nº da Venda no Parceiro": "N.º de venta en el socio comercial",
    "Não Abasteceu": "No cargó combustible",
    "Não Identificado": "No identificado",
    "Não Resgatou": "No canjeó",
    "Não abasteceu": "No cargó combustible",
    "Não cadastrado": "No registrado",
    "Não definida": "No definida",
    "Observação opcional sobre o pagamento": "Observación opcional sobre el pago",
    "Onde sua rede está no mercado": "Dónde está su red en el mercado",
    "PDF, PNG ou JPG (máx. 10MB)": "PDF, PNG o JPG (máx. 10MB)",
    "Pagamento registrado com sucesso!": "¡Pago registrado con éxito!",
    "Pagar Parceiro": "Pagar socio comercial",
    "Pix gerados": "Pix generados",
    "Pix pagos": "Pix pagados",
    "Pontos Pendentes": "Puntos pendientes",
    "Pontos Vitalícios": "Puntos vitalicios",
    "Pontos a Expirar": "Puntos por vencer",
    "Pontos expirados": "Puntos vencidos",
    "Pontos por Produto da Venda": "Puntos por producto de la venta",
    "Pontuou": "Puntuó",
    "Por Status": "Por estado",
    "Porcentagem de desconto": "Porcentaje de descuento",
    "Postos Ativos": "Estaciones activas",
    "Postos Favoritos": "Estaciones favoritas",
    "Postos Sem Internet (": "Estaciones sin internet (",
    "Postos a Expirar": "Estaciones por vencer",
    "Postos de Combustível": "Estaciones de servicio",
    "Preço Unitário": "Precio unitario",
    "Primeiro Abastecimento de Clientes": "Primera carga de combustible de clientes",
    "Primeiro Abastecimento por Frentista": "Primera carga de combustible por playero",
    "Primeiro Abastecimento por Posto": "Primera carga de combustible por estación",
    "Produtos em Estoque": "Productos en inventario",
    "Qnt. Abastecimentos": "Cant. de cargas de combustible",
    "RG": "RG",
    "Recalculado/agendado. Confira novamente.": "Recalculado/programado. Verifique nuevamente.",
    "Receita Pix": "Ingresos por Pix",
    "Recompensas entregues": "Recompensas entregadas",
    "Registrar Pagamento de Parceiro": "Registrar pago de socio comercial",
    "Relatório de Cobranças": "Reporte de cobros",
    "Relatório de Estoque Mínimo": "Reporte de inventario mínimo",
    "Relatório de Expiração de pontos": "Reporte de vencimiento de puntos",
    "Relatório de Notificações": "Reporte de notificaciones",
    "Relatório de Parceiros": "Reporte de socios comerciales",
    "Relatório de Parceiros Externos": "Reporte de socios externos",
    "Relatório de Pontos não Utilizados": "Reporte de puntos no utilizados",
    "Relatório de Posição de Estoque": "Reporte de posición de inventario",
    "Relatório de Produtos": "Reporte de productos",
    "Relatório de Sorteios": "Reporte de sorteos",
    "Relatório de sugestão de compra": "Reporte de sugerencia de compra",
    "Relatório de valores por parceiros": "Reporte de valores por socios comerciales",
    "Resumo do Pagamento": "Resumen del pago",
    "Saldo Min.": "Saldo mín.",
    "Saldo Máx.": "Saldo máx.",
    "Saldo Vitalício Restante": "Saldo vitalicio restante",
    "Selecione um Sorteio": "Seleccione un sorteo",
    "Selecione um arquivo": "Seleccione un archivo",
    "Selecione uma regra para visualizar o relatório.": "Seleccione una regla para visualizar el reporte.",
    "Sem Revenda": "Sin revendedor",
    "Sem envio no período.": "Sin envíos en el período.",
    "Sem envio suficiente no período pra comparar.": "Sin envíos suficientes en el período para comparar.",
    "Sem limite": "Sin límite",
    "Status do pagamento": "Estado del pago",
    "Taxa de leitura (": "Tasa de lectura (",
    "Tipo de transação": "Tipo de transacción",
    "Totais por Produto": "Totales por producto",
    "Totais por Status": "Totales por estado",
    "Total de Avaliações": "Total de calificaciones",
    "Total de Clientes": "Total de clientes",
    "Transações Dotz - Abastecimento": "Transacciones Dotz - Carga de combustible",
    "Transações de expiração": "Transacciones de vencimiento",
    "Usou desconto": "Usó descuento",
    "Utilizadas": "Utilizadas",
    "Utilização": "Utilización",
    "Valor (Dotz)": "Valor (Dotz)",
    "Valor (R$)": "Valor (R$)",
    "Valor Cashback": "Valor de cashback",
    "Valor Total (Dotz)": "Valor total (Dotz)",
    "Valor Total (R$)": "Valor total (R$)",
    "Valor abastecido": "Valor cargado",
    "Valor do Parceiro:": "Valor del socio comercial:",
    "Valor dos Abastecimentos": "Valor de las cargas de combustible",
    "Valor dos parceiros": "Valor de los socios comerciales",
    "Valor total dos boletos:": "Valor total de los boletos:",
    "Valores": "Valores",
    "Volume (L)": "Volumen (L)",
    "Volume Total (L)": "Volumen total (L)",
    "Volume dos Abastecimentos": "Volumen de las cargas de combustible",
    "Volume enviado e taxa de leitura por hora do dia — ajuda a escolher quando disparar": "Volumen enviado y tasa de lectura por hora del día — ayuda a elegir cuándo enviar",
    "Volume total (L)": "Volumen total (L)",
    "abastecimentos ativos": "cargas de combustible activas",
    "atualização": "actualización",
    "com erro de envio": "con error de envío",
    "disparos": "envíos",
    "mensagens em": "mensajes en",
    "recalcular": "recalcular",
    "sobre enviadas": "sobre enviadas",
    "É brinde": "Es premio",
    "É necessário definir um filtro de Tipo de transação para exibir o relátorio.": "Es necesario definir un filtro de tipo de transacción para mostrar el reporte.",
    "× parceiros": "× socios comerciales",
    "✅ Bateu — valores por parceiro == cupons validados (R$": "✅ Coincide — valores por socio comercial == cupones validados (R$",
    "❌ Diferença R$": "❌ Diferencia R$",
};

export default catalogo;
